import React, { useState, useEffect } from 'react';
import { Circle } from 'lucide-react';
import {
  Select,
  MenuItem,
  FormControl,
  Box,
  CircularProgress,
} from '@mui/material';
import chatService from "@/modules/vendor/service/chat.service";


// Define the available status options
const statusOptions = [
  { value: 'pending', label: 'Pending', color: '#EAB308' },
  { value: 'in_progress', label: 'In Progress', color: '#3B82F6' },
  { value: 'awaiting_documents', label: 'Awaiting Documents', color: '#EF4444' },
  { value: 'completed', label: 'Completed', color: '#22C55E' }
];

// Component to handle the status dropdown
function StatusDropdown({ conversationId, user }) {
  const [selectedStatus, setSelectedStatus] = useState('pending');
  const [loading, setLoading] = useState(false);

  const fetchConversationStatus = async () => {
    try {
      const response = await chatService.getVendorConversation(user._id);
      setSelectedStatus(response.data.data.status);
    } catch (error) {
      console.error("Error fetching conversation:", error);
    }
  };

  useEffect(() => { fetchConversationStatus(); }, [user]);

  // Function to handle the status update
  const updateStatus = async (event) => {
    const newStatus = event.target.value;
    // setSelectedStatus(newStatus);
    try {
      setLoading(true);
      // Update the status of the conversation using the provided API
      const updatedConversation = await chatService.updateVendorConversationStatus(conversationId, newStatus);
      setSelectedStatus(updatedConversation.data.data.status);
      // setSelectedStatus(newStatus);  // Update the local state to reflect the new status
    } catch (error) {
      console.error("Error during update flow:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <Select
        value={selectedStatus}
        onChange={updateStatus}
        disabled={loading}
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          },
          height: 40,
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              },
            },
          },
        }}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Circle
                size={16}
                style={{
                  color: option.color,
                  fill: option.color
                }}
              />
              {option.label}
            </Box>
          </MenuItem>
        ))}
      </Select>
      {loading && (
        <CircularProgress
          size={20}
          sx={{
            position: 'absolute',
            right: -28,
            top: '50%',
            marginTop: '-10px',
          }}
        />
      )}
    </FormControl>
  );
}


export default StatusDropdown;
